<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="70px" :hide-required-asterisk="true">
        <div>
          <el-form-item label="考试名称" prop="batchId" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-select v-model="form.batchId" placeholder="选择考试" :disabled="row && !!row.batchId" filterable style="width: 100%;">
              <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择文件" prop="fileUrl" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-upload class="inline-block" action="" :http-request="uploadOSS" :show-file-list="false" accept=".xls,.xlsx">
              <el-button type="default" style="color: #1890FF;margin-left: 0px;">导入名单</el-button>
            </el-upload>
            <el-progress v-if="!Tool.isNull(form.fileUrlProcess)" :percentage="Tool._toFixed(form.fileUrlProcess*100,0)"></el-progress>
            <el-input class="none" type="text" v-model="form.fileUrl" :maxlength="1024"></el-input>
            <div v-if="form.fileUrl">
              <div class="border inline-block" style="margin-top: 10px;">
                <i class="icon icon_explain pointer" style="font-size: 30px;"></i>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', form)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null,
      batchList: []
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async uploadOSS (event) {
      try {
        this.form.fileUrl = await this.$HTTP.ApiOss.uploadOSS(event.file, `importExam`, '.xls,.xlsx', 'temp', (p) => {
          this.form.fileUrlProcess = p
          this.$forceUpdate()
        })
        this.$forceUpdate()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async initForm () {
      this.batchList = await this.$HTTP.ApiBatch.getList()
      // console.log(this.batchList);
      if (this.Tool.isNull(this.batchList)) {
        throw new Error('没有考试数据')
      }
      if (!this.Tool.isNull(this.row)) {
        let info = JSON.parse(JSON.stringify(this.row))
        info.fileUrl = ''
        info.taskName = 'import_evaluate_allot'
        this.form = info
      } else {
        this.form = {
          fileUrl: '',
          taskName: 'import_evaluate_allot',
          batchId: this.batchList[0].batchId
        }
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        await this.$HTTP.GradeRoom.getImportExamAllot({
          roomId: this.$route.query.roomId,
          fileUrl: this.form.fileUrl
        })
        this.$emit('close', this.form)
      }
    }
  }
}
</script>
